<template>
  <gj-modal
    size="normal"
    notFooterPadding
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>编辑标签</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item
          label="评论内容"
          prop="content"
          class="edit-tags"
          :rules="[
            {
              message: '请输入标签名称',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <div style="line-height: 24px;">{{ tag.content }}</div>
        </el-form-item>
        <el-form-item
          label="已选标签"
          prop="parentId"
          :rules="[
            {
              message: '请选择标签',
              trigger: ['blur'],
            },
          ]"
          class="setting-wrapper"
        >
          <span v-for="(item,index) in tags" :key="index">
            <gj-tag
              :color="tagColors.orange"
              type="plain"
              :closable="true"
              @close="close(item)"
              >{{ item.name }}</gj-tag
            >
          </span>
          <div>
            <tag-cascader v-model="form.tagId" @change="changeSelect"></tag-cascader>
            <span class="setting-icon"
                  v-if="$permission('tag:view')"
                  @click="$router.push({path: '/crm/tag-manager'})">
              <gj-icon class="el-icon-setting"></gj-icon>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="desc" style="margin-bottom: 0">
          <gj-textarea
            v-model="form.memo"
            :styles="{ height: '120px', width: '100%' }"
          >
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {
  modalMixIn,
  formRuleMixin,
  responseMixin,
} from "../../../../../minxins";
import { getActiveTag, saveTagToRelation } from "../../../../../api/common";
import { tagColors } from "@/components/tag/tag-colors";
import  tagCascader  from '@/components/cascader/gj-tag-cascader'

export default {
  name: "app-tag-edit-modal",
  mixins: [modalMixIn, formRuleMixin, responseMixin],
  props: {
    tag: {
      required: true,
    },
  },
  components:{tagCascader},
  data() {
    return {
      tagColors,
      confirmLoading: false,
      form: {
        name: null,
        state: null,
        memo: null,
        parentId: null,
        id: null,
        tagId: null,
      },
      options: [],
      tags: [],
      isKey:0
    };
  },
  created() {
    this.queryData();
    this.form.name = this.tag.name;
    this.form.memo = this.tag.memo;
    this.form.id = this.tag.id;
    this.tags = this.tag.tags?this.tag.tags:[];
    this.form.tagId = this.tags.map((item) => {
      return item.id;
    });
  },
  watch:{
    $route:{
      immediate:true,
      handler(to,from){
        if(from.path==='/crm/tag-manager'){
          this.queryData();
          this.isKey++
        }
      }
    }
  },
  methods: {
    changeSelect() {
        this.tags=[];
        this.options.map((item)=>{
            this.form.tagId.map((n)=>{
                if(item.id===n && !item.disabled){
                    this.tags.push({id:n,name:item.text})
                }
            })
        })
    },

    // 删除标签
    close(tag) {
      this.tags = this.tags.filter((item) => item.id !== tag.id);
      this.form.tagId = this.tags.map((item) => {
        return item.id;
      });
    },
    queryData() {
      this.loading = true;
      const params={
          fid: this.tag.id,
          module: "Review",
      }
      getActiveTag(params)
        .then((res) => {
          this.options = res;
        })
        .complete(() => (this.loading = false));
    },
    confirm() {
      if (this.$gjFormValidate()) {
        this.confirmLoading = true;
        const params = {
          asin: this.tag.asin,
          //   countryCode: this.tag.countryCode,
          fid: this.tag.id,
          marketId: this.tag.marketId,
          orderId:this.tag.orderIds,
          memo: this.form.memo,
          module: "Review",
          tagIds: this.form.tagId,
          reviewId:this.tag.reviewCode

        };
        saveTagToRelation(params)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success("编辑标签成功");
              this.$emit("created");
              this.$gjDestroy();
            });
          })
          .complete(() => {
            this.confirmLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.gj-modal--normal .el-dialog{
  width: 700px;
}
.el-tag /deep/ .el-tag__close {
  color: rgb(255, 153, 0);
}
.el-tag /deep/ .el-tag__close:hover {
  color: #fff;
  background-color: rgb(255, 153, 0);
}
  .setting-icon {
    font-size: 16px;
    margin-left: 4px;
    display: none;
    cursor: pointer;
  }
  .setting-wrapper:hover .setting-icon {
    display: inline;
    line-height: 1;
  }
.edit-tags{
  /deep/ .el-form-item__label, /deep/.el-form-item__content{
    line-height: 24px;
  }
  margin-bottom: 24px;
}
</style>
